import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import requests from 'app/requests/Account.requests'

export default (ids: number[]) => {
    return useRequest({
        key: RequestKeys.getAccounts,
        params: {
            includeFilters: {
                id: ids,
            },
        },
        requestFunc: RequestFn.getEntity(requests.getAccounts, async (promise) => {
            const resp = await promise

            return resp?.data?.items
        }),
        keepPreviousData: true,
        enabled: Boolean(ids.length),
    })
}
